import { render, staticRenderFns } from "./PageFlight.vue?vue&type=template&id=e772c31e&"
import script from "./PageFlight.vue?vue&type=script&lang=js&"
export * from "./PageFlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports